module.exports = __webpack_public_path__ + "img/Premium Statistics.607595b7.png";